<script setup lang="ts">
import type { ColorBaseToken } from '#theme'
import { UIButton } from '#components'
import { computed, useRouter } from '#imports'

export interface GlobalNotificationButtonProps {
    href?: string
    color?: ColorBaseToken
}

const props = defineProps<GlobalNotificationButtonProps>()

const router = useRouter()

const canRender = computed(() => {
    const href = props.href
    if (!href) return false
    if (/^(?:https?:|mailto:|tel:)/i.test(href)) return true
    return router.resolve(href).matched.length > 0
})
</script>

<template>
    <UIButton
        v-if="canRender"
        :to="href"
        :color="color"
        size="sm"
    >
        <slot />
    </UIButton>
</template>
